export default "__VITE_ASSET__b941be45__"